import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../_services/dashboard.service';
import { DashboardNumbers } from 'src/app/_models/dashboardNumbers';
import { fadeInOnEnterAnimation } from 'angular-animations';
import { forkJoin } from 'rxjs';
import { DepreciationService } from 'src/app/financialTransaction/_services/depreciation.service';
import { Router } from '@angular/router';
import { NotifyService } from 'src/app/_services/notify.service';

@Component({
   selector: 'app-dashboard-numbers',
   templateUrl: './dashboard-numbers.component.html',
   styleUrls: ['./dashboard-numbers.component.scss'],
   animations: [fadeInOnEnterAnimation()],
})
export class DashboardNumbersComponent implements OnInit {
   monthEndDate: Date;
   constructor(private service: DashboardService, private depService: DepreciationService, private notify: NotifyService, private router: Router) {}
   dashboardNumbers: DashboardNumbers;

   loadingNumbers = false;
   smtpHostDefault: boolean;
   smtpHostError: boolean;
   isDepRun = false;

   ngOnInit() {
      this.loadingNumbers = true;
      forkJoin([this.service.getDashboardNumbers(), this.depService.getDepreciation(), this.service.getDashboardSmtp()]).subscribe({
         next: ([data, dep, smtp]) => {
            this.monthEndDate = dep.monthEndDate;
            this.loadingNumbers = false;
            this.dashboardNumbers = data;
            this.smtpHostDefault = smtp.hostDefault;
            this.smtpHostError = smtp.hostError;
            if(dep.lastDepreciationDate  != '0001-01-01T00:00:00' && dep.lastDepreciationDate  != 'NEVER' && !(dep.lastDepreciationDate  != '0001-01-01T00:00:00' &&  
dep.nextDepreciationDate =='APPROVAL PENDING') )
                this.isDepRun = true;
         },
         error: (error) => {
            this.loadingNumbers = false;
            const message = 'Failed to load dashboard numbers: ' + error;
            this.notify.error(message);
         },
      });
   }
   openReportDepartment() {
      this.router.navigate(['reports/DashCompOverview']);
   }
   openReportClassification() {
      this.router.navigate(['reports/DashAssetClassOverview']);
   }
   openReportSupplier() {
      this.router.navigate(['reports/DashSupplierOverview']);
   }
   refresh() {
      this.loadingNumbers = true;
      this.service.refresh().subscribe({
         next: (data) => {
            this.loadingNumbers = false;
            this.dashboardNumbers = data;
         },
         error: (error) => {
            this.loadingNumbers = false;
            const message = 'Failed to refresh dashboard numbers: ' + error;
            this.notify.error(message);
         },
      });
   }
}
